// `src/i18n/zh.js`
import news1img1 from '../pages/News/img/news1/img1.jpeg';
import news1img2 from '../pages/News/img/news1/img2.jpeg';
import news1img3 from '../pages/News/img/news1/img3.jpeg';
import news1img4 from '../pages/News/img/news1/img4.jpeg';

// 第二篇文章圖片
import glassSystem from '../pages/News/img/news2/img1.jpeg';
import glassBoothMap from '../pages/News/img/news2/img2.jpeg';
import glassHallMap from '../pages/News/img/news2/img3.jpeg';
import glassQr from '../pages/News/img/news1/img4.jpeg';

// 第三篇文章圖片
import batterySummitImg1 from '../pages/News/img/news3/img1.jpeg';
import batterySummitImg2 from '../pages/News/img/news3/img2.jpeg';
import batterySummitImg3 from '../pages/News/img/news3/img3.jpeg';

// 第四篇文章圖片
import batteryPreviewImg from '../pages/News/img/news4/img1.jpg';

// 第五篇文章圖片
import aquatechImg1 from '../pages/News/img/news5/img1.png';
import aquatechImg2 from '../pages/News/img/news5/img2.jpeg';

// 第六篇文章圖片
import aquatechPreviewImg1 from '../pages/News/img/news6/img1.png';

// 第七篇文章圖片
import apfeImg1 from '../pages/News/img/news7/img1.jpeg';

// 第八篇文章圖片
import apfePreviewImg1 from '../pages/News/img/news8/img1.png';

// 第九篇文章圖片
import chinaplasImg1 from '../pages/News/img/news9/img1.jpeg';
import  chinaplasImg2 from '../pages/News/img/news9/img2.jpeg';
import  chinaplasImg3 from '../pages/News/img/news9/img3.jpeg';

const en = {
  nav: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    about: 'About Us',
    news: 'News',
    contact: 'Contact'
  },
  home: {
    banner_title: 'Welcome to MicroVision',
    banner_subtitle: 'Focused on smart inspection and automation solutions'
  },
  megaMenu: {
    products: {
      category1: { title: 'Web Ranger' },
      category2: { title: 'Smart Cameras' },
      category3: { title: 'Surface Lighting' },
      category4: { title: 'Detection Software' },
      category5: { title: 'Automation Solutions' }
    }
  },
  banner: {
    // camera: {
    //   title: 'Achieving Peak Performance\nWith Imaging Technology',
    //   subtitle: '',
    //   description: 'IMAGING SOLUTIONS FOR PEAK PERFORMANCE',
    //   buttonText: 'Surface Inspection System'
    // },
    sensor: {
      title: 'Achieving Peak Performance\nWith Imaging Technology',
      subtitle: '',
      description: 'IMAGING SOLUTIONS FOR PEAK PERFORMANCE',
      buttonText: 'Industrial Camera'
    },
    lighting: {
      title: 'Precision Illumination\nEnhanced Defect Visibility',
      subtitle: '',
      description: 'PATENTED SURFACE LIGHTING FOR HIGH-RES INSPECTION',
      buttonText: 'Lighting'
    },
    software: {
      title: 'AI-Powered Classification Software\nHigh-Performance Imaging Pioneer',
      subtitle: '',
      description: 'AI-POWERED CLASSIFICATION SOFTWARE FOR HIGH-PERFORMANCE IMAGING',
      buttonText: 'Software'
    },
    automation: {
      title: 'High-Speed Inline Marking\nFor Defect Traceability',
      subtitle: '',
      description: 'AUTO LABELER & MARKING SOLUTIONS FOR QUALITY WORKFLOWS',
      buttonText: 'Labeler'
    },
    inspection: {
      title: 'Achieving Peak Performance\nWith Imaging Technology',
      subtitle: '',
      description: 'COMPREHENSIVE INSPECTION SYSTEMS FOR QUALITY ASSURANCE',
      buttonText: 'Labeling Machine'
    },
    learnMore: 'Learn More'
  },
  solutions: {
    sectionTitle: 'OUR SOLUTION',
    film: { title: 'Film', description: 'High-precision inspection solutions' },
    battery: { title: 'Lithium Battery', description: 'Improve battery production yield' },
    pcb: { title: 'Printed Circuit Board', description: 'Ensure circuit board quality' },
    nonwoven: { title: 'Non-woven Fabric', description: 'Precise material defect identification' },
    metal: { title: 'Metal', description: 'Surface defects detection' },
    paper: { title: 'Paper', description: 'Ensure paper printing quality' },
    solar: { title: 'Solar', description: 'Optimize solar panel performance' },
    general: { title: 'Glass', description: 'Comprehensive glass inspection solutions' }
  },
  heroSection: {
    title: 'Precise Identification of Every Defect\nEnsuring Zero Quality Errors',
    description: 'Trust Wintriss Engineering to create\nthe most suitable surface inspection system for your industry',
    button: 'Request Quote'
  },
  about: {
    title: 'ABOUT',
    wintrissTitle: "Providing the Industry's Most Advanced and Stable Inspection and Automation Solutions",
    paragraph1: 'Wintriss Engineering has specialized in inspection equipment for over 25 years, accumulating comprehensive experience in optical design, algorithm development, and production line integration. Building on this foundation we deliver a new generation of surface inspection systems featuring high-speed full-color industrial line scan cameras and refined algorithms that help customers precisely control material surface quality.\n' +
      '\n' +
      'We also independently develop\nin-line X-ray thickness measurement equipment that measures thickness and basis weight in real time to enhance process stability. For the cleanliness demands of advanced materials, in 2025 we launched an in-line ultrasonic dust removal system achieving over 99.5% cleaning efficiency, effectively reducing defect rates caused by contaminants.',
    paragraph2: '',
    learnMore: 'Learn More'
  },
  footer: {
    address: 'No. 1009, Ln. 401, Sec. 7, Chengd Rd., Beitou Dist., Taipei City, Taiwan',
    phone: '886-2-2892-8000',
    copyright: 'All Rights Reserved',
    products: {
      title: 'PRODUCTS',
      surfaceInspectionSystem: 'Surface Inspection System',
      industrialCamera: 'Industrial Camera',
      lighting: 'Lighting',
      software: 'Software',
      labeler: 'Labeler'
    },
    solutions: {
      title: 'SOLUTIONS',
      film: 'Film',
      nonwoven: 'Nonwoven',
      solar: 'Solar',
      battery: 'Battery',
      metal: 'Metal',
      glass: 'Glass',
      pcb: 'PCB (Printed Circuit Board)',
      paper: 'Paper'
    },
    company: {
      title: 'COMPANY',
      about: 'About Us',
      contact: 'Contact Us'
    }
  },
  aboutUs: {
    hero: {
      title: 'About Wintriss Engineering',
      subtitle: 'Leading Brand in Industrial Vision Inspection'
    },
    intro: {
      title: 'Company History',
      description: 'Wintriss Engineering has specialized in inspection equipment for over 25 years, accumulating comprehensive experience in optical design, algorithm development, and production line integration. Building on this foundation we deliver a new generation of surface inspection systems featuring high-speed full-color industrial line scan cameras and refined algorithms that help customers precisely control material surface quality.\n' +
        '\n' +
        'We also independently develop\nin-line X-ray thickness measurement equipment that measures thickness and basis weight in real time to enhance process stability. For the cleanliness demands of advanced materials, in 2025 we launched an in-line ultrasonic dust removal system achieving over 99.5% cleaning efficiency, effectively reducing defect rates caused by contaminants.\n' +
        '\n' +
        'In addition, the PROTHERM infrared heating panels represented by Wintriss Engineering use high-efficiency electrical heating to provide fast, uniform and energy-saving thermal processing performance suitable for a wide range of material treatment workflows.'
    },
    vision: {
      title: 'Our Vision',
      content: 'To become a leading brand in the global industrial vision inspection field.'
    },
    mission: {
      title: 'Our Mission',
      content: 'Through precise inspection technology, help customers improve production efficiency.'
    },
    values: {
      title: 'Core Values',
      innovation: { title: 'Innovation', description: 'Continuous R&D of advanced technology' },
      quality: { title: 'Quality', description: 'Pursuing excellence in quality standards' },
      service: { title: 'Service', description: 'Providing premium customer service' }
    }
  },
  news: {
    title: 'Latest News',
    subtitle: 'Stay informed on exhibitions and technology updates',
    readMore: 'Read More',
    back: 'Back to List',
    list: {
      cidpex2018: {
        id: 'cidpex-2018',
        title: 'Exhibition Preview: Wintriss Engineering Invites You to the 25th International Tissue Paper Technology Exhibition & Conference (CIDPEX 2018)',
        date: '2018-04-18 ~ 2018-04-20',
        summary: 'Wintriss Engineering will appear at CIDPEX 2018 and invites you to visit Booth Hall7 7S37.',
        sections: [
          {
            type: 'text',
            content: 'Wintriss Engineering, a global leader in surface defect inspection solutions, will exhibit at the 25th International Tissue Paper Technology Exhibition & Conference (CIDPEX 2018) held April 18–20, 2018. We sincerely invite you to visit our booth (Hall7 7S37) and talk with our inspection experts.'
          },
          {
            type: 'text',
            content: 'We sincerely invite you to visit the Wintriss Engineering booth (Hall7 7S37) to exchange with our inspection experts and learn more about leading automated surface defect inspection technologies in the tissue paper sector.'
          },
          { type: 'image', src: news1img1, alt: 'Wintriss Engineering Tissue Defect Inspection System' },
          {
            type: 'text',
            title: 'Detectable Defect Types',
            content: 'Holes, spots, black dots, insects, impurities, dust, scratches, wrinkles, broken edges, high-contrast streaks, adhesive residues, and other contaminants.'
          },
          { type: 'image', src: news1img2, alt: 'Hall 7 Booth Map' },
          { type: 'image', src: news1img3, alt: 'Venue Layout' },
          {
            type: 'text',
            title: 'Wintriss Engineering Booth Information',
            content: 'Nanjing International Expo Center｜Hall 7 7S37｜April 18–20'
          },
          {
            type: 'text',
            title: 'About Us',
            content: 'Wintriss Engineering Inspection Technologies was founded in 1989 and is headquartered in San Diego, California, USA. The company is dedicated to the R&D and application of smart cameras. Its flagship products are line-scan smart camera surface defect inspection systems, making it a leader in surface quality inspection. Wintriss Engineering holds patented camera, lighting, and core software technologies. Its Asia offices are located in Taiwan, Shanghai, Suzhou, Japan, Korea, Malaysia, and India, jointly providing users across Asia with high-quality and efficient services.'
          },
          {
            type: 'text',
            title: 'Contact Information',
            content: 'Sales Department | Tel: 86-21-61283990 / 61918662 | Fax: 86-21-61918683 | Email: sales@iwscan.com'
          },
          {
            type: 'text',
            title: 'Follow Us',
            content: 'Please continue to follow us for the latest technology and exhibition information.'
          },
          { type: 'image', src: news1img4, alt: 'Follow Us QR Code' }
        ]
      },
      chinaglass2018: {
        id: 'chinaglass-2018',
        title: 'Exhibition Preview: Wintriss Engineering Invites You to the 29th China International Glass Industry Exhibition (Chinaglass)',
        date: '2018-04-19 ~ 2018-04-22',
        summary: 'Welcome to the Shanghai New International Expo Center Hall E2 Booth E2-141 for glass defect inspection technology discussion.',
        sections: [
          {
            type: 'text',
            content: 'Wintriss Engineering, a global leader in surface defect inspection solutions, cordially invites you to attend the 29th China International Glass Industry Exhibition (Chinaglass) held April 19–22, 2018, and to exchange in-depth with our inspection experts on automated glass surface defect inspection technologies.'
          },
          {
            type: 'text',
            title: 'Technical Advantages',
            content: 'Multiple image processing and optical imaging patents enable WebRanger to detect various challenging glass surface defects, helping quality control, improving efficiency, and reducing costs.'
          },
          { type: 'image', src: glassSystem, alt: 'Wintriss Engineering Glass Inspection System' },
          {
            type: 'text',
            title: 'Concept',
            content: 'A global leader in surface defect inspection, committed to achieving [zero] defects.'
          },
          {
            type: 'text',
            title: 'Global Installations',
            content: 'Wintriss Engineering has deployed thousands of systems across North America, Asia, and Europe.'
          },
          {
            type: 'text',
            title: 'Booth Information',
            content: 'Shanghai New International Expo Centre | Hall E2 Booth E2-141'
          },
          {
            type: 'text',
            title: 'Expo Schedule',
            content: 'Apr 19–21 09:00–17:30 | Apr 22 09:00–13:00'
          },
          { type: 'image', src: glassBoothMap, alt: 'Hall E2 Floor Plan' },
          { type: 'image', src: glassHallMap, alt: 'Venue Layout' },
          {
            type: 'text',
            title: 'About Us',
            content: 'Wintriss Engineering Inspection Technologies was founded in 1989 and is headquartered in San Diego, California, USA. It focuses on line-scan smart camera surface defect inspection systems and holds patented camera, lighting, and core software technologies. Its Asian locations cover Taiwan, Shanghai, Suzhou, Japan, Korea, Malaysia, and India.'
          },
          {
            type: 'text',
            title: 'Contact Information',
            content: 'Sales Department | Tel: 86-21-61918662 | Fax: 86-21-61918683 | Email: sales@iwscan.com'
          },
          { type: 'image', src: glassQr, alt: 'Follow Us QR Code' },
          {
            type: 'text',
            title: 'Release Date',
            content: '2018-03-26'
          }
        ]
      },
      batterySummit2017: {
        id: 'battery-summit-2017',
        title: 'Congratulations: Wintriss Engineering at 2017 Global Battery Film Summit',
        date: '2017-06-15 ~ 2017-06-16',
        summary: 'Wintriss Engineering shared aluminum plastic film defect inspection experience in Shanghai.',
        sections: [
          {
            type: 'text',
            content: 'On June 15-16 the 2017 Battery Film Summit in Shanghai gathered leaders and experts from the U.S., Japan, Korea, Taiwan and Mainland China.'
          },
          {
            type: 'text',
            content: 'Executives from many listed companies attended, including Sony, Celanese, Cangzhou Mingzhu, Senior, BenQ Materials, Lucky Film, DM Optics, Tianhong, Foster, Kangdexin, Nan Ya Plastics, Akcome, Taimide, Jingmao, HAIYU, and Liaoyuan Hongtu.'
          },
          {
            type: 'text',
            content: 'As a leader in surface defect inspection, Wintriss Engineering presented solutions to detect aluminum plastic film defects, improving quality and efficiency.'
          },
          { type: 'image', src: batterySummitImg1, alt: 'CEO visit' },
          { type: 'image', src: batterySummitImg2, alt: 'Roundtable' },
          { type: 'image', src: batterySummitImg3, alt: 'Forum' },
          { type: 'text', title: 'Release Date', content: '2017-06-19' }
        ]
      },
      batterySummit2017Preview: {
        id: 'battery-summit-2017-preview',
        title: 'Exhibition Preview: Wintriss Engineering Invites You to the Global Battery Film Summit Shanghai',
        date: '2017-06-15 ~ 2017-06-16',
        summary: 'Wintriss will attend the 2nd Global Battery Film Summit in Shanghai to share defect inspection solutions.',
        sections: [
          {
            type: 'text',
            content: 'Wintriss Engineering will attend the June 15-16 2017 2nd Global Battery Film Summit in Shanghai organized by China Plastic Film Network and Unima New Materials Network.'
          },
          {
            type: 'text',
            content: 'We will present professional surface defect inspection solutions for aluminum plastic and battery film materials, joining hundreds of industry companies to build a healthy ecosystem.'
          },
          { type: 'image', src: batteryPreviewImg, alt: 'Preview' },
          {
            type: 'text',
            title: 'Release Date',
            content: '2017-06-13'
          }
        ]
      },
      aquatech2017: {
        id: 'aquatech-2017',
        title: 'Congratulations: Wintriss Engineering 2017 AQUATECH Success',
        date: '2017-06-07 ~ 2017-06-09',
        summary: 'Participated in AQUATECH CHINA Shanghai International Water Expo, sharing online surface defect inspection achievements and technology.',
        sections: [
          {
            type: 'text',
            content: 'The world\'s largest international water treatment exhibition, AQUATECH CHINA (Shanghai International Water Expo), was held June 7–9 at the National Exhibition and Convention Center (Shanghai Hongqiao). Wintriss Engineering was honored to participate and share years of achievements and experience in online surface defect inspection.'
          },
          {
            type: 'text',
            content: 'Visitors gained a deeper understanding of our advanced surface defect inspection technologies and equipment, and further recognized our corporate culture. Moving forward together toward shared success.'
          },
          { type: 'image', src: aquatechImg1, alt: 'AQUATECH expo scene' },
          { type: 'image', src: aquatechImg2, alt: 'AQUATECH expo scene 2' },
          {
            type: 'text',
            title: 'Release Date',
            content: '2017-06-12'
          }
        ]
      },
      aquatech2017Preview: {
        id: 'aquatech-2017-preview',
        title: 'Exhibition Preview: Wintriss Engineering to Attend 2017 AQUATECH International Water Expo',
        date: '2017-06-07 ~ 2017-06-09',
        summary: 'Visit booth 8.1H813 for professional water filtration membrane defect inspection solutions.',
        sections: [
          {
            type: 'text',
            content: 'The world\'s largest international water treatment exhibition, AQUATECH CHINA (Shanghai International Water Expo), will be held June 7–9 at the National Exhibition and Convention Center (Shanghai Hongqiao). Wintriss Engineering will participate; our booth number is 8.1H813.'
          },
          {
            type: 'text',
            content: 'You are welcome to visit our booth for face-to-face discussions with the leader in surface defect inspection and obtain professional inline water filtration membrane inspection solutions.'
          },
          { type: 'image', src: aquatechPreviewImg1, alt: 'AQUATECH preview' },
          {
            type: 'text',
            title: 'Release Date',
            content: '2017-06-05'
          }
        ]
      },
      apfe2017: {
        id: 'apfe-2017',
        title: 'Congratulations: Wintriss Engineering 2017 APFE Success',
        date: '2017-05-24 ~ 2017-05-26',
        summary: 'Participated in the 13th APFE Shanghai International Adhesive Tape, Protective Film & Optical Film and Functional Film Exhibition, sharing surface inspection technology achievements.',
        sections: [
          {
            type: 'text',
            content: 'The creator of global professional tape and film exhibitions—APFE. The 13th Shanghai International Adhesive Tape, Protective Film & Optical Film Exhibition & the 13th Shanghai International Functional Film Exhibition was held May 24–26, 2017 at the National Exhibition and Convention Center (Shanghai Hongqiao).'
          },
          {
            type: 'text',
            content: 'As a leader in inline inspection, Wintriss achieved outstanding results, helping more customers gain deeper understanding of our advanced surface inspection technologies, equipment, and corporate culture.'
          },
          { type: 'image', src: apfeImg1, alt: 'APFE expo scene' },
          { type: 'text', title: 'Release Date', content: '2017-06-05' }
        ]
      },
      apfe2017Preview: {
        id: 'apfe-2017-preview',
        title: 'Exhibition Preview: Wintriss to Attend 2017 APFE',
        date: '2017-05-24 ~ 2017-05-26',
        summary: 'Visit booth T120 for professional adhesive tape and film surface inspection solutions.',
        sections: [
          {
            type: 'text',
            content: 'The creator of professional global tape and film exhibitions—APFE—the 13th Shanghai International Adhesive Tape, Protective Film & Optical Film Exhibition & the 13th Shanghai International Functional Film Exhibition will be held May 24–26, 2017 at the National Exhibition and Convention Center (Shanghai Hongqiao).'
          },
          {
            type: 'text',
            content: 'Wintriss Engineering will participate; our booth number is T120. You are welcome to visit for face-to-face discussions with the leader in surface defect inspection and obtain the most professional solutions.'
          },
          { type: 'image', src: apfePreviewImg1, alt: 'APFE preview' },
          { type: 'text', title: 'Release Date', content: '2017-05-21' }
        ]
      },
      chinaplas2017: {
        id: 'chinaplas-2017',
        title: 'Congratulations: Wintriss Engineering 2017 CHINAPLAS Success',
        date: '2017-05-16 ~ 2017-05-19',
        summary: 'Participated in CHINAPLAS 2017, sharing achievements and experience in online surface defect inspection.',
        sections: [
          {
            type: 'text',
            content: 'The 31st CHINAPLAS International Exhibition on Plastics and Rubber Industries was held May 16–19, 2017 at the Pazhou Complex in Guangzhou. Wintriss Engineering was honored to participate.'
          },
          {
            type: 'text',
            content: 'During the show we shared years of achievements and insights in online surface defect inspection, helping visitors gain deeper understanding of our advanced inspection technologies, equipment, and corporate culture. Moving forward together toward shared success.'
          },
          { type: 'image', src: chinaplasImg1, alt: 'CHINAPLAS expo scene' },
          { type: 'image', src: chinaplasImg2, alt: 'CHINAPLAS expo scene2' },
          { type: 'image', src: chinaplasImg3, alt: 'CHINAPLAS expo scene3' },
          { type: 'text', title: 'Release Date', content: '2017-05-21' }
        ]
      },
      chinaplas2017Preview: {
        id: 'chinaplas-2017-preview',
        title: 'Exhibition Preview: Wintriss Engineering to Attend 2017 CHINAPLAS',
        date: '2017-05-16 ~ 2017-05-19',
        summary: 'Visit booth 9.2J21 to learn surface defect inspection solutions for rubber & plastics.',
        sections: [
          {
            type: 'text',
            content: 'Wintriss Engineering, a global leader in surface defect inspection solutions, invites you to attend CHINAPLAS 2017 (May 16–19). Booth: 9.2J21.'
          },
          {
            type: 'text',
            title: 'Official Website',
            content: 'More info: https://www.chinaplasonline.com/'
          },
          {
            type: 'text',
            title: 'Event Info',
            content: '31st International Exhibition on Plastics and Rubber Industries｜Date: May 16–19, 2017｜Opening Hours: 09:30–17:00'
          },
          {
            type: 'text',
            title: 'Venue',
            content: 'China Import & Export Fair Complex, Pazhou, Guangzhou (No. 382 Yuejiang Middle Road)'
          },
          {
            type: 'text',
            title: 'Organizers & Co-Organizers',
            content: 'Adsale Exhibition Services Ltd.; Beijing Yazhan Exhibition Services Ltd.; China National Light Industry Council – China Plastics Processing Industry Association; China Plastics Machinery Industry Association; Guangdong Plastics Industry Association; Messe Düsseldorf (China) Ltd.; Shanghai Plastics Industry Association'
          },
          {
            type: 'text',
            title: 'Sponsor',
            content: 'EUROMAP (European Association of Plastics and Rubber Machinery Manufacturers)'
          },
          {
            type: 'text',
            title: 'Overseas Support',
            content: 'Japan Plastics Machinery Association'
          },
          {
            type: 'text',
            title: 'Domestic Support',
            content: 'Anhui Plastics Association; China Rubber Industry Association; Fujian Plastics Industry Association; Jiangsu Plastics Processing Association; Jiangxi Plastics Industry Association; Shandong Plastics Industry Association; Shenzhen Polymer Association; Taizhou Plastics Industry Association; Zhejiang Plastics Industry Association'
          },
          { type: 'text', title: 'Release Date', content: '2017-05-04' }
        ]
      }
    },
    fallback: { title: 'Content unavailable' }
  }
};

export default en;

